export default "__VITE_ASSET__DgRQScb2__"